import { NavLink, useNavigate } from 'react-router-dom';
import './company.scss';
import { useDispatch, useSelector } from 'react-redux';
import { setNav_Item } from '../../redux/NavBarSlice';
import { useState } from 'react';
import MainSideColumn from '../../Components/sidebars/MainSideColumn';
import { hide } from '../../redux/SideBarSlice';
import { ABOUTUS, DIRECT_CARDS } from './constant';
import SEO from '../../seo/SEO';
import RightContentColumn from "../../Components/sidebars/RightContentColumn ";


const Company = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  const visible = useSelector((state) => state.sidebarItem.visible);
  const source = useSelector((state) => state.sidebarItem.source);
  console.log("Redux state:", { visible, source });
  const dispatch = useDispatch()

  function handleProductClick(index) {
    //  setActiveIndex(index);
    dispatch(hide())
    navigate(ABOUTUS[index].path);
  }

  const state = useSelector((state) => state.sidebarItem);
  console.log("Current state:", state);

  return (
    <>
      <SEO
        title="About Utilitarian Labs | Our Story, Impact & Team"
        description="Learn about Utilitarian Labs—our story, values, impact, culture, and partnerships driving meaningful Salesforce-led transformation."
      />

      {visible && source === "aboutus" && (
        <div className="product-container">
          <MainSideColumn
            products={ABOUTUS}
            activeIndex={activeIndex}
            onProductClick={handleProductClick}
            title="About Us"
          />

          {/* RIGHT – Cards */}
          <RightContentColumn cards={DIRECT_CARDS} />
        </div>
      )}
    </>
  );
};

export default Company